import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Contact = () => {
  return (
    <ContactSection
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Title>{'<Contact />'}</Title>
      <ContentWrapper>
        <Heading>Get In Touch</Heading>
        <Description>
          I'm currently open for opportunities. Whether you have a question or just 
          want to say hi, I'll try my best to get back to you!
        </Description>
        <Form>
          <InputGroup>
            <Input type="text" placeholder="Name" required />
          </InputGroup>
          <InputGroup>
            <Input type="email" placeholder="Email" required />
          </InputGroup>
          <InputGroup>
            <TextArea placeholder="Message" required />
          </InputGroup>
          <SubmitButton
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Send Message
          </SubmitButton>
        </Form>
      </ContentWrapper>
    </ContactSection>
  );
};

const ContactSection = styled(motion.section)`
  min-height: 100vh;
  padding: 100px 10% 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h2`
  color: #64ffda;
  font-size: 2rem;
  margin-bottom: 2rem;
`;

const ContentWrapper = styled.div`
  max-width: 600px;
  width: 100%;
  text-align: center;
`;

const Heading = styled.h3`
  color: #ccd6f6;
  font-size: 3rem;
  margin-bottom: 1rem;
`;

const Description = styled.p`
  color: #8892b0;
  margin-bottom: 2rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const InputGroup = styled.div`
  position: relative;
`;

const Input = styled.input`
  width: 100%;
  padding: 1rem;
  background: #112240;
  border: 1px solid #233554;
  border-radius: 4px;
  color: #ccd6f6;
  font-family: 'Courier New', Courier, monospace;

  &:focus {
    outline: none;
    border-color: #64ffda;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 1rem;
  background: #112240;
  border: 1px solid #233554;
  border-radius: 4px;
  color: #ccd6f6;
  font-family: 'Courier New', Courier, monospace;
  min-height: 150px;

  &:focus {
    outline: none;
    border-color: #64ffda;
  }
`;

const SubmitButton = styled(motion.button)`
  padding: 1rem 2rem;
  background: transparent;
  border: 1px solid #64ffda;
  border-radius: 4px;
  color: #64ffda;
  font-family: 'Courier New', Courier, monospace;
  cursor: pointer;
  margin-top: 1rem;

  &:hover {
    background: rgba(100, 255, 218, 0.1);
  }
`;

export default Contact;